import { render } from "./ValidationAccountForm.vue?vue&type=template&id=69e64011"
import script from "./ValidationAccountForm.vue?vue&type=script&lang=js"
export * from "./ValidationAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__